import { Typography } from '@occc-app/design-system';
import {
  DateTimeFormat,
  DateTimeFormatTZ,
  formatDateTime,
  formatDateTimeTZ,
  getUserTimezone,
} from '@occc-app/lib/date';

type AudienceSizeSubheaderProps = {
  isDraft: boolean;
  isCalculating: boolean;
  lastDraftCountCalculationAt?: string | null;
  actualAsOf?: Date;
};

export const AudienceSizeSubheader = ({
  isDraft,
  isCalculating,
  lastDraftCountCalculationAt,
  actualAsOf,
}: AudienceSizeSubheaderProps) => {
  const isDraftCalculating = isDraft && isCalculating;
  const isDraftWithLastCalculation = isDraft && !isCalculating && lastDraftCountCalculationAt;

  if (isDraftCalculating) {
    return (
      <Typography variant='body2' color='text.secondary'>
        Calculating...
      </Typography>
    );
  }

  if (isDraftWithLastCalculation) {
    return (
      <Typography variant='body2' color='text.secondary'>
        {`as of ${formatDateTime(
          new Date(lastDraftCountCalculationAt),
          DateTimeFormat.DateTime12h,
        )}`}
      </Typography>
    );
  }

  if (actualAsOf) {
    const timeZone = getUserTimezone();
    return (
      <Typography variant='body2' color='text.secondary'>
        {`as of ${formatDateTimeTZ(
          actualAsOf,
          timeZone,
          DateTimeFormatTZ.DateTimeSlashed12hWithShortTimeZone,
        )}`}
      </Typography>
    );
  }

  return undefined;
};
